import React from 'react';
import { motion } from 'framer-motion';
import './styles.scss';
import config from 'config';
import DeleteIcon from 'assets/icons/delete_user_icon.svg';
import EditIcon from 'assets/icons/edit_list_item_icon.svg';
import { eventfilterTableItemContentMotion } from './animation';
import { IEventFilterTableItemProps } from './interface';

function EventFilterTableItem({
    item,
    onDelete,
    onEdit,
}: IEventFilterTableItemProps) {
    const currentDate = new Date();
    return (
        <motion.div
            {...eventfilterTableItemContentMotion}
            className='event-filter-table-item'
        >
            <div className='event-filter-table-item__clicable'>
                <div className='event-filter-table-item__clicable__left-field'>
                    <div className='event-filter-table-item__clicable__left-field__img'>
                        <img
                            src={`${config.API_URL}/events/images/${item.Id}?date=${currentDate}`}
                            alt='Item Img'
                        />
                    </div>
                </div>
                <div className='event-filter-table-item__clicable__left-field'>
                    <p>{item.Eventlanguages[0].Name}</p>
                </div>
                <div className='event-filter-table-item__clicable__right-field'>
                    <p>{item.Eventlanguages[0].Description}</p>
                    <button
                        type='button'
                        className='event-filter-table-item__clicable__right-field__edit-button'
                        onClick={onEdit}
                    >
                        <img src={EditIcon} alt='Edit Icon' />
                    </button>
                    <button
                        type='button'
                        className='event-filter-table-item__clicable__right-field__delete-button'
                        onClick={onDelete}
                    >
                        <img src={DeleteIcon} alt='Delete Icon' />
                    </button>
                </div>
            </div>
        </motion.div>
    );
}

export default EventFilterTableItem;
